/**
 * Remove o efeito skeleton e exibe o conteúdo da página após o carregamento.
 */
jQuery(window).on('load', function() {
    $('.loading-skeleton').hide()
    $(this).remove();
    $('.page-content').show()
});

/**
 * Configurações padrões para o select2.
 */
 jQuery.fn.select2.defaults.set('language', {
    errorLoading: function () {
        return "Não foi possível obter os resultados.";
    },
    inputTooLong: function (args) {
        return `Por favor informe, no máximo, <strong>${args.maximum} caracter(es)</strong>...`;
    },
    inputTooShort: function (args) {
        return `Por favor informe, pelo menos, <strong>${args.minimum} caracter(es)</strong>...`;
    },
    loadingMore: function () {
        return "Carregando mais resultados...";
    },
    maximumSelected: function (args) {
        return `Por favor selecione, no máximo, <strong>${args.maximum} opções(es)</strong>...`;
    },
    noResults: function () {
        return "Nenhum resultado encontrado.";
    },
    searching: function () {
        return "Buscando...";
    }
});

/**
 * Override the default yii confirm dialog. This function is
 * called by yii when a confirmation is requested.
 *
 * @param message the message to display
 * @param okCallback triggered when confirmation is true
 * @param cancelCallback callback triggered when cancelled
 */
yii.confirm = function (message, okCallback, cancelCallback) {
    bootbox.confirm({
        message: message,
        size: 'md',
        buttons: {
            confirm: {
                label: '<i class="fa fa-check"></i> Sim',
                className: 'btn btn-wired btn-square btn-sm btn-danger'
            },
            cancel: {
                label: '<i class="fa fa-times"></i> Não',
                className: 'btn btn-wired btn-square btn-sm btn-secondary'
            }
        },
        callback: function (result) {
            if (result) {
                !okCallback || okCallback();
            } else {
                !cancelCallback || cancelCallback();
            }
        }
    });

    // confirm will always return false on the first call
    // to cancel click handler
    return false;
};

/**
 * Add or replace params in url.
 *
 * @param url
 * @param params
 * @param encodeUsingComponent
 * @returns {*}
 */
function urlReplaceParams(url, params, encodeUsingComponent) {
    if (typeof params === typeof undefined || params.length === 0) {
        params = {};
    }

    if (typeof encodeUsingComponent === typeof undefined || typeof encodeUsingComponent !== "boolean") {
        encodeUsingComponent = false;
    }

    Object.keys(params).map(function(objectKey, index) {
        let paramName = encodeUsingComponent ? encodeURIComponent(objectKey) : encodeURI(objectKey),
            paramValue = encodeUsingComponent ? encodeURIComponent(params[objectKey]) : encodeURI(params[objectKey]);

        const pattern = new RegExp('\\b('+paramName+'=).*?(&|$)');

        //Replace or add
        if (url.search(pattern) >= 0) {
            url = url.replace(pattern, '$1' + paramValue + '$2');
        } else {
            url += (url.indexOf('?') < 0 ? '?' : '&') + paramName + '=' + paramValue;
        }
    });
    return url;
}

/**
 * CONFIGURAÇÕES BOOTBOX
 */
bootbox.setDefaults({
    /**
     * @optional String
     * @default: en
     * which locale settings to use to translate the three
     * standard button labels: OK, CONFIRM, CANCEL
     */
    locale: "pt",

    /**
     * @optional Boolean
     * @default: null
     * Whether the dialog should be have a backdrop or not. Also determines whether clicking on the backdrop dismisses the modal.
     */
    backdrop: true,

    /**
     * @optional Boolean
     * @default: true for alert, confirm, and prompt; null for custom dialogs.
     * Allows the user to dismiss the dialog by hitting ESC, which will invoke this function.
     */
    onEscape: function () {
       if ($('#form-tarefa').length) {
           return false;
       }

       return true;
    },

    /**
     * @optional Boolean
     * @default: true
     * show a close button
     */
    closeButton: true,

    /**
     * @optional String
     * @default: null
     * Adds the relevant Bootstrap modal size class to the dialog wrapper. Valid values are:
     */
    size: "xl",

    /**
     * @optional Boolean
     * @default: false,
     * If true, the modal-dialog-centered class will be added to the dialog wrapper.
     */
    centerVertical: false,

    /**
     * @optional Boolean
     * @default: false,
     * If true, the modal-dialog-scrollable class will be added to the dialog wrapper. Enable this option to have the content of long modals automatically scroll.
     */
    scrollable: true,

    /**
     * Adds a header to the dialog and places this text (or markup ) in an <h5> element.
     */
    title: "",
});

/**
 * ModalHelper
 * @constructor
 */
function ModalHelper (options) {
    this.options = (typeof options === typeof undefined || options === null) ? {} : options;
}

/**
 * Carregar um conteúdo específico.
 * @param url
 */
ModalHelper.prototype.load = function(url) {
    url = typeof url === typeof undefined ? undefined : url;
    if (typeof url === typeof undefined || url === "" || url === null || url === "#") {
        return;
    }

    /**
     * Inicialização do bootbox (modal).
     */
    const dialog = bootbox.dialog({
        message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Carregando...</div>',
        ...this.options,
    });
    
    $('.close').addClass('btn btn-sm btn-icon btn-active-color-primary fs-3 h-20px w-20px')

    dialog.init(function() {
        jQuery.ajax({
            type: "GET",
            url: url
        }).done(function(response, status, jqXHR) {
            if (jqXHR.getResponseHeader("content-type").indexOf("text/html") >= 0) {
                dialog.find(".bootbox-body").empty().html(response);
            } else {
                dialog.modal("hide");
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            dialog.find(".bootbox-body").empty().modal("hide");
        });
    });
};

/**
 * Carregar um conteúdo específico.
 * @param url
 */
ModalHelper.prototype.confirm = function(url) {
    url = typeof url === typeof undefined ? undefined : url;
    if (typeof url === typeof undefined || url === "" || url === null || url === "#") {
        console.info("Favor informe uma url válida para realizar esta ação.");
        return;
    }

    /**
     * Inicialização do bootbox (confirm/prompt).
     */
    bootbox.prompt({
        inputType: 'password',
        placeholder: "Digite sua senha",
        buttons: {
            confirm: {
                label: '<i class="fa fa-check"></i> Confirmar',
                className: 'btn btn-wired btn-square btn-sm btn-danger'
            },
            cancel: {
                label: '<i class="fa fa-times"></i> Cancelar',
                className: 'btn btn-wired btn-square btn-sm btn-secondary'
            }
        },
        callback: function (result) {
            if (result === null || result === "") {
                return null;
            }

            jQuery.ajax({
                type: "POST",
                url: url,
                data: {password: result}
            }).done(function(response, status, jqXHR) {
                try {
                    const responseJson = jQuery.parseJSON(response);
                    if (responseJson.hasOwnProperty("message")) {
                        const typeError = responseJson.hasOwnProperty("error") && responseJson.error;
                        Swal.fire({
                            icon: typeError ? "warning" : "success",
                            title: responseJson.message,
                            showConfirmButton: false,
                            timer: 1700
                        })
                    }

                    if (responseJson.hasOwnProperty("reload") && responseJson.reload) {
                        Swal.fire({
                            icon: "info",
                            title: "A tela será recarregada, aguarde...",
                        })
                        setTimeout(function() {
                            location.reload();
                        }, 3000);
                    }
                } catch (error) {
                    console.error(error);
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                console.error(errorThrown);
            });
        },
        ...this.options,
    });

    $('.close').remove()
};

/**
 * Carregar um conteúdo específico.
 * @param url
 * @param token
 */
ModalHelper.prototype.arquivo = function(url, token) {
    url = typeof url === typeof undefined ? undefined : url;
    if (typeof url === typeof undefined || url === "" || url === null || url === "#") {
        console.info("Favor informe uma url válida para realizar esta ação.");
        return;
    }

    /**
     * Inicialização do bootbox (confirm/prompt).
     */
    bootbox.prompt({
        inputType: 'password',
        placeholder: "Digite sua senha",
        buttons: {
            confirm: {
                label: '<i class="fa fa-check"></i> Confirmar',
                className: 'btn btn-wired btn-square btn-sm btn-danger'
            },
            cancel: {
                label: '<i class="fa fa-times"></i> Cancelar',
                className: 'btn btn-wired btn-square btn-sm btn-secondary'
            }
        },
        callback: function (result) {
            if (result === null || result === "") {
                return null;
            }

            jQuery.ajax({
                type: "POST",
                url: url,
                data: {password: result, arquivoDeletado: token}
            }).done(function(response, status, jqXHR) {
                try {
                    const responseJson = jQuery.parseJSON(response);
                    if (responseJson.hasOwnProperty("message")) {
                        const typeError = responseJson.hasOwnProperty("error") && responseJson.error;
                        if (typeError) {
                            Swal.fire({
                                icon: "warning",
                                title: responseJson.message,
                                showConfirmButton: false,
                                timer: 1700
                            })
                        } else {
                            Swal.fire({
                                toast: true,
                                position: 'top-end',
                                title: responseJson.message,
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1700,
                            })
                        }

                        if (typeError === false) {
                            $(document).find("a[data-arquivo-token='" + token + "']").closest('.arquivos').hide();
                        }
                        $(document).ready(function () {
                            // Necessário para que os dropdowns funcionem no modal
                            KTMenu.createInstances();
                            $('#tarefa-fornecedoresids, #tarefa-participantesids').each(function(){
                                $(this).select2({
                                    dropdownParent: $(".modal-content"),
                                    allowClear: true,
                                    multiple: true,
                                    placeholder: "-",
                                });
                            });
                            $('.select2-selection--multiple').addClass('form-select')
                        });
                    }

                } catch (error) {
                    console.error(error);
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                console.error(errorThrown);
            });
        },
        ...this.options,
    });

    $('div.el_modal_delete_arquivo_tarefa .close').remove()
};

/**
 * Requisitar/executar uma url específica.
 * @param url
 * @param type
 */
ModalHelper.prototype.execute = function(url, type) {
    url = typeof url === typeof undefined ? undefined : url;
    if (typeof url === typeof undefined || url === "" || url === null || url === "#") {
        console.info("Favor informe uma url válida para realizar esta ação.");
        return;
    }

    if (["POST", "GET"].includes(type) === false) {
        type = "POST";
    }

    Swal.fire({
        icon: "info",
        title: "Aguarde...",
    })
    jQuery.ajax({
        type: type,
        url: url,
        contentType: "application/json; charset=utf-8",
    }).done(function(response, status, jqXHR) {
        try {
            const responseJson = jQuery.parseJSON(response);
            if (responseJson.hasOwnProperty("message")) {
                const typeError = responseJson.hasOwnProperty("error") && responseJson.error;
                Swal.fire({
                    icon: typeError ? "warning" : "success",
                    title: responseJson.message,
                    showConfirmButton: false,
                    timer: 1700
                  })
            }

            if (responseJson.hasOwnProperty("reload") && responseJson.reload) {
                Swal.fire({
                    icon: "info",
                    title: "A tela será recarregada, aguarde...",
                })
                setTimeout(function() {
                    location.reload();
                }, 3000);
            }
        } catch (error) {
            console.error(error);
        }
    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
    });
};

/**
 * Carregar um link específico em um modal.
 */
jQuery(document).on("click", "a[data-modal-type='modal']", function(e) {
    e.preventDefault();
    const title = e.currentTarget.getAttribute("data-modal-title"),
        titleIcon = e.currentTarget.getAttribute("data-modal-title-icon"),
        identifier = e.currentTarget.getAttribute("data-modal-identifier"),
        size = e.currentTarget.getAttribute("data-modal-size");

    let params = {
        size: (typeof size === typeof undefined || size === null || size === "") ? 'xl' : size,
        title: (typeof title === typeof undefined || title === null || title === "") ? "" : title,
        titleIcon: (typeof titleIcon === typeof undefined || titleIcon === null || titleIcon === "") ? null : titleIcon,
        className: (typeof identifier === typeof undefined || identifier === null || identifier === "") ? null : identifier,
    };

    const modal = new ModalHelper(params);
    modal.load(e.currentTarget.getAttribute("href"));
});

/**
 * Executar uma ação específica que necessita de senha.
 */
jQuery(document).on("click", "a[data-modal-type='confirm']", function(e) {
    e.preventDefault();
    const title = e.currentTarget.getAttribute("data-modal-title"),
        titleIcon = e.currentTarget.getAttribute("data-modal-title-icon"),
        identifier = e.currentTarget.getAttribute("data-modal-identifier"),
        size = e.currentTarget.getAttribute("data-modal-size");

    let params = {
        size: (typeof size === typeof undefined || size === null || size === "") ? 'xl' : size,
        title: (typeof title === typeof undefined || title === null || title === "") ? "" : title,
        titleIcon: (typeof titleIcon === typeof undefined || titleIcon === null || titleIcon === "") ? null : titleIcon,
        className: (typeof identifier === typeof undefined || identifier === null || identifier === "") ? null : identifier,
    };

    const modal = new ModalHelper(params);
    modal.confirm(e.currentTarget.getAttribute("href"));
});

/**
 * Executar uma ação específica que necessita de senha.
 */
jQuery(document).on("click", "a[data-modal-type='arquivo']", function(e) {
    e.preventDefault();
    const title = e.currentTarget.getAttribute("data-modal-title"),
        titleIcon = e.currentTarget.getAttribute("data-modal-title-icon"),
        identifier = e.currentTarget.getAttribute("data-modal-identifier"),
        size = e.currentTarget.getAttribute("data-modal-size");

    let params = {
        size: (typeof size === typeof undefined || size === null || size === "") ? 'xl' : size,
        title: (typeof title === typeof undefined || title === null || title === "") ? "" : title,
        titleIcon: (typeof titleIcon === typeof undefined || titleIcon === null || titleIcon === "") ? null : titleIcon,
        className: (typeof identifier === typeof undefined || identifier === null || identifier === "") ? null : identifier,
    };

    const modal = new ModalHelper(params);
    modal.arquivo(e.currentTarget.getAttribute("href"),e.currentTarget.getAttribute("data-arquivo-token"));
});

/**
 * Executar uma ação específica.
 */
jQuery(document).on("click", "a[data-modal-type='execute']", function(e) {
    e.preventDefault();
    const modal = new ModalHelper();
    modal.execute(e.currentTarget.getAttribute("href"), e.currentTarget.getAttribute("data-modal-execute-type"));
});

/**
 * Identificar envio de formulários dentro do bootbox.
 */
jQuery(document).on("submit", "div.bootbox form", function(e) {
    e.preventDefault();
    e.stopPropagation();

    $('.btn-salvar').addClass('disabled');

    const form = jQuery(this),
        dialog = form.closest('div.bootbox');

    let formData = new FormData(this);
    jQuery.ajax({
        type: "POST",
        url: form.attr('action'),
        data: formData,
        cache: false,
        contentType: false,
        processData: false
    }).done(function(response, status, jqXHR) {
        $('.btn-salvar').removeClass('disabled');

        if (jqXHR.getResponseHeader("content-type").indexOf("text/html") >= 0) {
            dialog.find(".bootbox-body").empty().html(response);
        } else {
            try {
                const responseJson = jQuery.parseJSON(response);
                if (responseJson.hasOwnProperty("message")) {
                    const typeError = responseJson.hasOwnProperty("error") && responseJson.error;
                    Swal.fire({
                        icon: typeError ? "warning" : "success",
                        title: responseJson.message,
                        showConfirmButton: false,
                        timer: 1700
                      })
                }

                if (responseJson.hasOwnProperty("redirectUrl") && responseJson.redirectUrl) {
                    // var target = responseJson.hasOwnProperty("redirectNewTab") && responseJson.redirectNewTab ? '_blank' : null;

                    if(responseJson.hasOwnProperty("redirectNewTab") && responseJson.redirectNewTab) {
                        // Botão que força o click criado para evitar que o navegador bloqueie a nova aba (bloqueador de popup)
                        var button = jQuery('body').attr('onclick', "window.open('"+responseJson.redirectUrl+"', '_blank')");
                        button.click();
                        button.removeAttr('onclick');
                    } else {
                        window.location = responseJson.redirectUrl;
                    }
                }

                if (responseJson.hasOwnProperty("reload") && responseJson.reload) {
                    Swal.fire({
                        icon: "info",
                        title: "A tela será recarregada",
                    })
                    setTimeout(function() {
                        location.reload();
                    }, 3000);
                }
            } catch(error) {
                console.error(error);
                dialog.modal("hide");
            }
        }
    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
        dialog.find(".bootbox-body").empty().modal("hide");
    });
});

let toggleTooltipTitleCollapse = function(elemToggle) {
    if(jQuery(elemToggle).closest('.kt-portlet').hasClass('kt-portlet--collapse')) {
        KTUtil.data(elemToggle).get('tooltip').updateTitleContent('Expandir');
    } else {
        KTUtil.data(elemToggle).get('tooltip').updateTitleContent('Fechar');
    }
};

// Ao carregar a tela
jQuery(function() {
    let elemToggle = jQuery('[data-ktportlet-tool=toggle]');

    if(elemToggle.length) {
        elemToggle.each(function(e) {
            toggleTooltipTitleCollapse(this);
        });

        elemToggle.on('click', function () {
            toggleTooltipTitleCollapse(this);
        });
    }
});

// Assiste o clique do usuário quando o modal está aberto
$(document).on('click', 'div.bootbox', function(e) {
    // modal-dialog box
    const hasDialogModalAround = $(e.target).closest('div.modal-dialog').length;
    if (!hasDialogModalAround) {
        if ($('div.bootbox').hasClass('el_modal_create_tarefa')) {
            location.reload();
        }
        $('body').removeClass('modal-open');
        $('div.bootbox').remove();
        $('div.modal-backdrop').remove();
    }
});

const updateURLParameter = function(url, parametro, valParametro) {
    var TheAnchor = null;
    var novaUrlAdicional = '';
    var urlArray = url.split("?");
    var baseURL = urlArray[0];
    var urlAdicional = urlArray[1];
    var separador ="";

    if (urlAdicional)
    {
        var parametrosArray = urlAdicional.split("#");
        var Parametros = parametrosArray[0];
        TheAnchor = parametrosArray[1];
        if(TheAnchor)
            urlAdicional = Parametros;

        urlArray = urlAdicional.split("&");

        for (var i=0; i<urlArray.length; i++)
        {
            if(urlArray[i].split('=')[0] != parametro)
            {
                novaUrlAdicional += separador + urlArray[i];
                separador = "&";
            }
        }
    }
    else
    {
        var parametrosArray = baseURL.split("#");
        var Parametros = parametrosArray[0];
        TheAnchor  = parametrosArray[1];

        if(Parametros)
            baseURL = Parametros;
    }

    if(TheAnchor)
        valParametro += "#" + TheAnchor;

    var parametros = separador + "" + parametro + "=" + valParametro;
    return baseURL + "?" + novaUrlAdicional + parametros;
}

var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};

function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
    });
}